import React from "react";
import EachBookingContainer from "./EachBookingContainer";
import HeaderText from "./HeaderText";
import { BookingHeader } from "./index";

const BookingStatusHeader = () => {
  return (
    <EachBookingContainer isHeader>
      {BookingHeader.map((eachHeader, index) => {
        return <HeaderText key={index} label={eachHeader.label} />;
      })}
    </EachBookingContainer>
  );
};

export default BookingStatusHeader;
